import * as React from "react";
const InputCheckIcon = ({
  size = 16,
  title = "InputCheckIcon",
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { width: size, height: size, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: "pds-icon", title, ...props }, /* @__PURE__ */ React.createElement("path", { d: "m6.991 10-.699.715.706.69.7-.697L6.99 10Zm-2.69-1.232 1.991 1.947 1.398-1.43L5.7 7.338l-1.4 1.43Zm3.397 1.94 4.008-4-1.412-1.416-4.01 4 1.414 1.416Z", fill: "currentColor" }));
export default InputCheckIcon;
